import { useState, useEffect } from 'react'
import axiosClient from '../axiosClient'

interface Country {
  iso: string
  name: string
}

interface CountryOption {
  value: string
  label: string
}

interface UseCountriesReturn {
  loading: boolean
  countries: Country[]
  countriesOptions: CountryOption[]
  error?: string
}

// Données de fallback en cas d'échec du backend
const FALLBACK_COUNTRIES: Country[] = [
  { iso: 'AD', name: 'Andorre' },
  { iso: 'AE', name: 'Émirats arabes unis' },
  { iso: 'AF', name: 'Afghanistan' },
  { iso: 'AG', name: 'Antigua-et-Barbuda' },
  { iso: 'AI', name: 'Anguilla' },
  { iso: 'AL', name: 'Albanie' },
  { iso: 'AM', name: 'Arménie' },
  { iso: 'AO', name: 'Angola' },
  { iso: 'AQ', name: 'Antarctique' },
  { iso: 'AR', name: 'Argentine' },
  { iso: 'AS', name: 'Samoa américaines' },
  { iso: 'AT', name: 'Autriche' },
  { iso: 'AU', name: 'Australie' },
  { iso: 'AW', name: 'Aruba' },
  { iso: 'AX', name: 'Îles Åland' },
  { iso: 'AZ', name: 'Azerbaïdjan' },
  { iso: 'BA', name: 'Bosnie-Herzégovine' },
  { iso: 'BB', name: 'Barbade' },
  { iso: 'BD', name: 'Bangladesh' },
  { iso: 'BE', name: 'Belgique' },
  { iso: 'BF', name: 'Burkina Faso' },
  { iso: 'BG', name: 'Bulgarie' },
  { iso: 'BH', name: 'Bahreïn' },
  { iso: 'BI', name: 'Burundi' },
  { iso: 'BJ', name: 'Bénin' },
  { iso: 'BL', name: 'Saint-Barthélemy' },
  { iso: 'BM', name: 'Bermudes' },
  { iso: 'BN', name: 'Brunéi Darussalam' },
  { iso: 'BO', name: 'Bolivie' },
  { iso: 'BQ', name: 'Bonaire, Saint-Eustache et Saba' },
  { iso: 'BR', name: 'Brésil' },
  { iso: 'BS', name: 'Bahamas' },
  { iso: 'BT', name: 'Bhoutan' },
  { iso: 'BV', name: 'Île Bouvet' },
  { iso: 'BW', name: 'Botswana' },
  { iso: 'BY', name: 'Bélarus' },
  { iso: 'BZ', name: 'Belize' },
  { iso: 'CA', name: 'Canada' },
  { iso: 'CC', name: 'Îles Cocos' },
  { iso: 'CD', name: 'République démocratique du Congo' },
  { iso: 'CF', name: 'République centrafricaine' },
  { iso: 'CG', name: 'Congo' },
  { iso: 'CH', name: 'Suisse' },
  { iso: 'CI', name: 'Côte d\'Ivoire' },
  { iso: 'CK', name: 'Îles Cook' },
  { iso: 'CL', name: 'Chili' },
  { iso: 'CM', name: 'Cameroun' },
  { iso: 'CN', name: 'Chine' },
  { iso: 'CO', name: 'Colombie' },
  { iso: 'CR', name: 'Costa Rica' },
  { iso: 'CU', name: 'Cuba' },
  { iso: 'CV', name: 'Cap-Vert' },
  { iso: 'CW', name: 'Curaçao' },
  { iso: 'CX', name: 'Île Christmas' },
  { iso: 'CY', name: 'Chypre' },
  { iso: 'CZ', name: 'République tchèque' },
  { iso: 'DE', name: 'Allemagne' },
  { iso: 'DJ', name: 'Djibouti' },
  { iso: 'DK', name: 'Danemark' },
  { iso: 'DM', name: 'Dominique' },
  { iso: 'DO', name: 'République dominicaine' },
  { iso: 'DZ', name: 'Algérie' },
  { iso: 'EC', name: 'Équateur' },
  { iso: 'EE', name: 'Estonie' },
  { iso: 'EG', name: 'Égypte' },
  { iso: 'EH', name: 'Sahara occidental' },
  { iso: 'ER', name: 'Érythrée' },
  { iso: 'ES', name: 'Espagne' },
  { iso: 'ET', name: 'Éthiopie' },
  { iso: 'FI', name: 'Finlande' },
  { iso: 'FJ', name: 'Fidji' },
  { iso: 'FK', name: 'Îles Malouines' },
  { iso: 'FM', name: 'Micronésie' },
  { iso: 'FO', name: 'Îles Féroé' },
  { iso: 'FR', name: 'France' },
  { iso: 'GA', name: 'Gabon' },
  { iso: 'GB', name: 'Royaume-Uni' },
  { iso: 'GD', name: 'Grenade' },
  { iso: 'GE', name: 'Géorgie' },
  { iso: 'GF', name: 'Guyane française' },
  { iso: 'GG', name: 'Guernesey' },
  { iso: 'GH', name: 'Ghana' },
  { iso: 'GI', name: 'Gibraltar' },
  { iso: 'GL', name: 'Groenland' },
  { iso: 'GM', name: 'Gambie' },
  { iso: 'GN', name: 'Guinée' },
  { iso: 'GP', name: 'Guadeloupe' },
  { iso: 'GQ', name: 'Guinée équatoriale' },
  { iso: 'GR', name: 'Grèce' },
  { iso: 'GS', name: 'Géorgie du Sud-et-les Îles Sandwich du Sud' },
  { iso: 'GT', name: 'Guatemala' },
  { iso: 'GU', name: 'Guam' },
  { iso: 'GW', name: 'Guinée-Bissau' },
  { iso: 'GY', name: 'Guyana' },
  { iso: 'HK', name: 'Hong Kong' },
  { iso: 'HM', name: 'Îles Heard-et-MacDonald' },
  { iso: 'HN', name: 'Honduras' },
  { iso: 'HR', name: 'Croatie' },
  { iso: 'HT', name: 'Haïti' },
  { iso: 'HU', name: 'Hongrie' },
  { iso: 'ID', name: 'Indonésie' },
  { iso: 'IE', name: 'Irlande' },
  { iso: 'IL', name: 'Israël' },
  { iso: 'IM', name: 'Île de Man' },
  { iso: 'IN', name: 'Inde' },
  { iso: 'IO', name: 'Territoire britannique de l\'océan Indien' },
  { iso: 'IQ', name: 'Irak' },
  { iso: 'IR', name: 'Iran' },
  { iso: 'IS', name: 'Islande' },
  { iso: 'IT', name: 'Italie' },
  { iso: 'JE', name: 'Jersey' },
  { iso: 'JM', name: 'Jamaïque' },
  { iso: 'JO', name: 'Jordanie' },
  { iso: 'JP', name: 'Japon' },
  { iso: 'KE', name: 'Kenya' },
  { iso: 'KG', name: 'Kirghizistan' },
  { iso: 'KH', name: 'Cambodge' },
  { iso: 'KI', name: 'Kiribati' },
  { iso: 'KM', name: 'Comores' },
  { iso: 'KN', name: 'Saint-Christophe-et-Niévès' },
  { iso: 'KP', name: 'Corée du Nord' },
  { iso: 'KR', name: 'Corée du Sud' },
  { iso: 'KW', name: 'Koweït' },
  { iso: 'KY', name: 'Îles Caïmans' },
  { iso: 'KZ', name: 'Kazakhstan' },
  { iso: 'LA', name: 'Laos' },
  { iso: 'LB', name: 'Liban' },
  { iso: 'LC', name: 'Sainte-Lucie' },
  { iso: 'LI', name: 'Liechtenstein' },
  { iso: 'LK', name: 'Sri Lanka' },
  { iso: 'LR', name: 'Libéria' },
  { iso: 'LS', name: 'Lesotho' },
  { iso: 'LT', name: 'Lituanie' },
  { iso: 'LU', name: 'Luxembourg' },
  { iso: 'LV', name: 'Lettonie' },
  { iso: 'LY', name: 'Libye' },
  { iso: 'MA', name: 'Maroc' },
  { iso: 'MC', name: 'Monaco' },
  { iso: 'MD', name: 'Moldavie' },
  { iso: 'ME', name: 'Monténégro' },
  { iso: 'MF', name: 'Saint-Martin' },
  { iso: 'MG', name: 'Madagascar' },
  { iso: 'MH', name: 'Îles Marshall' },
  { iso: 'MK', name: 'Macédoine du Nord' },
  { iso: 'ML', name: 'Mali' },
  { iso: 'MM', name: 'Myanmar' },
  { iso: 'MN', name: 'Mongolie' },
  { iso: 'MO', name: 'Macao' },
  { iso: 'MP', name: 'Îles Mariannes du Nord' },
  { iso: 'MQ', name: 'Martinique' },
  { iso: 'MR', name: 'Mauritanie' },
  { iso: 'MS', name: 'Montserrat' },
  { iso: 'MT', name: 'Malte' },
  { iso: 'MU', name: 'Maurice' },
  { iso: 'MV', name: 'Maldives' },
  { iso: 'MW', name: 'Malawi' },
  { iso: 'MX', name: 'Mexique' },
  { iso: 'MY', name: 'Malaisie' },
  { iso: 'MZ', name: 'Mozambique' },
  { iso: 'NA', name: 'Namibie' },
  { iso: 'NC', name: 'Nouvelle-Calédonie' },
  { iso: 'NE', name: 'Niger' },
  { iso: 'NF', name: 'Île Norfolk' },
  { iso: 'NG', name: 'Nigéria' },
  { iso: 'NI', name: 'Nicaragua' },
  { iso: 'NL', name: 'Pays-Bas' },
  { iso: 'NO', name: 'Norvège' },
  { iso: 'NP', name: 'Népal' },
  { iso: 'NR', name: 'Nauru' },
  { iso: 'NU', name: 'Niue' },
  { iso: 'NZ', name: 'Nouvelle-Zélande' },
  { iso: 'OM', name: 'Oman' },
  { iso: 'PA', name: 'Panama' },
  { iso: 'PE', name: 'Pérou' },
  { iso: 'PF', name: 'Polynésie française' },
  { iso: 'PG', name: 'Papouasie-Nouvelle-Guinée' },
  { iso: 'PH', name: 'Philippines' },
  { iso: 'PK', name: 'Pakistan' },
  { iso: 'PL', name: 'Pologne' },
  { iso: 'PM', name: 'Saint-Pierre-et-Miquelon' },
  { iso: 'PN', name: 'Îles Pitcairn' },
  { iso: 'PR', name: 'Porto Rico' },
  { iso: 'PS', name: 'Palestine' },
  { iso: 'PT', name: 'Portugal' },
  { iso: 'PW', name: 'Palaos' },
  { iso: 'PY', name: 'Paraguay' },
  { iso: 'QA', name: 'Qatar' },
  { iso: 'RE', name: 'La Réunion' },
  { iso: 'RO', name: 'Roumanie' },
  { iso: 'RS', name: 'Serbie' },
  { iso: 'RU', name: 'Russie' },
  { iso: 'RW', name: 'Rwanda' },
  { iso: 'SA', name: 'Arabie saoudite' },
  { iso: 'SB', name: 'Îles Salomon' },
  { iso: 'SC', name: 'Seychelles' },
  { iso: 'SD', name: 'Soudan' },
  { iso: 'SE', name: 'Suède' },
  { iso: 'SG', name: 'Singapour' },
  { iso: 'SH', name: 'Sainte-Hélène' },
  { iso: 'SI', name: 'Slovénie' },
  { iso: 'SJ', name: 'Svalbard et Jan Mayen' },
  { iso: 'SK', name: 'Slovaquie' },
  { iso: 'SL', name: 'Sierra Leone' },
  { iso: 'SM', name: 'Saint-Marin' },
  { iso: 'SN', name: 'Sénégal' },
  { iso: 'SO', name: 'Somalie' },
  { iso: 'SR', name: 'Suriname' },
  { iso: 'SS', name: 'Soudan du Sud' },
  { iso: 'ST', name: 'Sao Tomé-et-Principe' },
  { iso: 'SV', name: 'El Salvador' },
  { iso: 'SX', name: 'Saint-Martin' },
  { iso: 'SY', name: 'Syrie' },
  { iso: 'SZ', name: 'Eswatini' },
  { iso: 'TC', name: 'Îles Turks-et-Caïcos' },
  { iso: 'TD', name: 'Tchad' },
  { iso: 'TF', name: 'Terres australes françaises' },
  { iso: 'TG', name: 'Togo' },
  { iso: 'TH', name: 'Thaïlande' },
  { iso: 'TJ', name: 'Tadjikistan' },
  { iso: 'TK', name: 'Tokelau' },
  { iso: 'TL', name: 'Timor oriental' },
  { iso: 'TM', name: 'Turkménistan' },
  { iso: 'TN', name: 'Tunisie' },
  { iso: 'TO', name: 'Tonga' },
  { iso: 'TR', name: 'Turquie' },
  { iso: 'TT', name: 'Trinité-et-Tobago' },
  { iso: 'TV', name: 'Tuvalu' },
  { iso: 'TW', name: 'Taïwan' },
  { iso: 'TZ', name: 'Tanzanie' },
  { iso: 'UA', name: 'Ukraine' },
  { iso: 'UG', name: 'Ouganda' },
  { iso: 'UM', name: 'Îles mineures éloignées des États-Unis' },
  { iso: 'US', name: 'États-Unis' },
  { iso: 'UY', name: 'Uruguay' },
  { iso: 'UZ', name: 'Ouzbékistan' },
  { iso: 'VA', name: 'Vatican' },
  { iso: 'VC', name: 'Saint-Vincent-et-les-Grenadines' },
  { iso: 'VE', name: 'Venezuela' },
  { iso: 'VG', name: 'Îles Vierges britanniques' },
  { iso: 'VI', name: 'Îles Vierges des États-Unis' },
  { iso: 'VN', name: 'Viêt Nam' },
  { iso: 'VU', name: 'Vanuatu' },
  { iso: 'WF', name: 'Wallis-et-Futuna' },
  { iso: 'WS', name: 'Samoa' },
  { iso: 'YE', name: 'Yémen' },
  { iso: 'YT', name: 'Mayotte' },
  { iso: 'ZA', name: 'Afrique du Sud' },
  { iso: 'ZM', name: 'Zambie' },
  { iso: 'ZW', name: 'Zimbabwe' }
].sort((a, b) => a.name.localeCompare(b.name))

const useCountriesAxios = (): UseCountriesReturn => {
  const [countries, setCountries] = useState<Country[]>(FALLBACK_COUNTRIES)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | undefined>(undefined)

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        setLoading(true)
        setError(undefined)
        
        // Appel à l'endpoint backend (même logique que GraphQL)
        const response = await axiosClient.get('/countries')
        
        if (response.data && Array.isArray(response.data)) {
          const sortedCountries = response.data.sort((a: Country, b: Country) => 
            a.name.localeCompare(b.name)
          )
          setCountries(sortedCountries)
        } else {
          throw new Error('Format de réponse invalide')
        }
      } catch (error) {
        console.error('Échec de récupération des pays depuis le backend:', error)
        setError('Impossible de charger la liste des pays depuis le serveur')
        // Utiliser les données de fallback statiques
        setCountries(FALLBACK_COUNTRIES)
      } finally {
        setLoading(false)
      }
    }

    fetchCountries()
  }, [])

  const countriesOptions: CountryOption[] = countries.map((country: Country) => ({
    value: country.iso,
    label: country.name
  }))

  return {
    loading,
    countries,
    countriesOptions,
    error
  }
}

export default useCountriesAxios
